import {ApiRequestEnum} from 'src/app/core/enums/api-request.enum';
import {ApiService} from 'src/app/core/services/api.service';
import {Injectable} from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class StudioService {
	constructor(
		private apiService: ApiService,
	) {
	}

	GetStudios(params) {
		return this.apiService.post(ApiRequestEnum.STUDIO_GET_ALL, params);
	}

	GetTopStudios() {
		return this.apiService.get(ApiRequestEnum.STUDIO_TOP);
	}

	LikeStudio(studioId: string) {
		return this.apiService.patch(
			ApiRequestEnum.STUDIO_LIKE.replace('{{studio_uuid}}', studioId)
		);
	}

	DisLikeStudio(studioId: string, likeId: string) {
		return this.apiService.delete(
			(ApiRequestEnum.STUDIO_DISLIKE.replace('{{studio_uuid}}', studioId)).replace('{{likeId}}', likeId)
		);
	}

	PostComment(studioId: string, param: any) {
		return this.apiService.patch(
			ApiRequestEnum.STUDIO_COMMENT.replace('{{studio_uuid}}', studioId),
			param
		);
	}
}
